export const payload = {
  receiveMutation: 'RECEIVE_COUNTRIES',
  receivingMutation: 'RECEIVING_COUNTRIES',
  receiveMetadataMutation: 'RECEIVE_COUNTRY_METADATA',
  receiveFailureMutation: 'RECEIVE_COUNTRY_FAILURE',
  savingMutation: 'SAVING_COUNTRY',
  saveFailureMutation: 'SAVING_COUNTRY_FAILURE',
  incrementMutation: 'INCREMENT_COUNTRY_COUNT',
  updatingMutation: 'UPDATING_COUNTRY',
  updateFailureMutation: 'UPDATING_COUNTRY_FAILURE',
  deleteMutation: 'DELETE_COUNTRY',
  deletingMutation: 'DELETING_COUNTRY',
  deleteFailureMutation: 'DELETING_COUNTRY_FAILURE',
  resetMetaMutation: 'RESET_COUNTRY_META',
  clearMutation: 'CLEAR_COUNTRY_STATE',
  moduleName: 'country',
  endpoint: 'countries',
  searchableFields: ['name']
}
